import { ReactNode, useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../../core/QueryRequestProvider'
import { useQueryResponse } from '../../../core/QueryResponseProvider'
import { useListFilters } from '../../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: "Nova versão"). */
  actions?: ReactNode
}

export const TermosListSearchComponent = ({ actions }: Props) => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(
    () => (debouncedFilters.titulo.trim() ? `titulo~*${debouncedFilters.titulo.trim()}*` : ''),
    [debouncedFilters]
  )

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  const activeFilters: ActiveFilter[] = filters.titulo.trim()
    ? [
        {
          key: 'titulo',
          label: 'Título',
          value: `“${filters.titulo.trim()}”`,
          onRemove: () => setFilter('titulo', ''),
        },
      ]
    : []

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'versão encontrada' : 'versões encontradas'}`
          }
        />
      }
    >
      <TableFilter label='Título' wide>
        <Input
          placeholder='Digite o título'
          value={filters.titulo}
          onChange={(e) => setFilter('titulo', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
